// Zoekvenster (Views/Partials/blocks/search.cshtml): openen via elke .js-zoek-link (metamenu en mobiel menu),
// sluiten via .js-zoekenClose of Escape. Bij openen krijgt het zoekveld de focus.
const panel = document.querySelector<HTMLElement>('.c-zoeken');

function setOpen(open: boolean) {
    if (!panel) { return; }
    panel.classList.toggle('is-open', open);
    if (open) {
        const input = panel.querySelector<HTMLInputElement>('input[type="search"]');
        if (input) { input.focus(); }
    }
}

for (const link of Array.from(document.querySelectorAll<HTMLElement>('.js-zoek'))) {
    link.addEventListener('click', (event) => {
        event.preventDefault();
        setOpen(true);
    });
}

for (const button of Array.from(document.querySelectorAll<HTMLElement>('.js-zoekenClose'))) {
    button.addEventListener('click', () => setOpen(false));
}

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel && panel.classList.contains('is-open')) { setOpen(false); }
});

export {};
